import { isApprovalAdmin } from 'utility/role-model'

// 2026-10-27: Monthly Rotation is built for Cintas (34930; 60551 = test company). Only company admins create it:
// super admin / IsAdmin / RoleId 3 (isApprovalAdmin) or RoleId 1000 (PROD Cintas admins are 1000 - the sidebar
// link checked RoleId 3 only, so they could no longer find the page).
export const MONTHLY_ROTATION_COMPANY_IDS = [34930, 60551]
export const MONTHLY_ROTATION_PATH = '/app/monthly-rotation'

export const isMonthlyRotationCompany = user =>
    !!user && MONTHLY_ROTATION_COMPANY_IDS.includes(Number(user.CompanyId))

export const canCreateMonthlyRotation = user =>
    isMonthlyRotationCompany(user) &&
    (isApprovalAdmin(user) || Number(user.RoleId ?? user.RoleID) === 1000)
